import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONITEM_LOAD_BY_TRIALINSTITUTION_ID,
    ACTION_TRIALINSTITUTIONITEM_LOAD_SITECLOSURE,
    ACTION_TRIALINSTITUTIONITEM_LOAD_FAILURE,
    ACTION_TRIALINSTITUTIONITEM_LOAD_SUCCESS,

    ACTION_TRIALINSTITUTIONITEM_SAVE,
    ACTION_TRIALINSTITUTIONITEM_SAVE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEM_SAVE_FAILURE,

    ACTION_TRIALINSTITUTIONITEM_CLEAR,
    TrialInstitutionItemAction,
    ACTION_TRIALINSTITUTIONITEM_CREATE,
    ACTION_TRIALINSTITUTIONITEM_CREATE_SUCCESS,
    ACTION_TRIALINSTITUTIONITEM_CREATE_FAILURE,
    ACTION_TRIALINSTITUTIONITEM_LOAD_BY_ID
} from '../actions/trialInstitutionItem';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from 'src/helpers/formErrorHelper';

export interface ITrialInstitutionItemState {
    formData: Dtos.TrialInstitutionItem | Dtos.TrialInstitutionItem[];
    groupedData: Dtos.TrialInstitutionItemCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialInstitutionItem[];
    groupedFilteredData: Dtos.TrialInstitutionItemCategory[];
    lookups: Dtos.Lookup[],
    validationFailures: Dtos.ResponseError[];
}

const initialState: ITrialInstitutionItemState = {
    formData: undefined,
    groupedData: undefined,
    formState: undefined,
    formProperties: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    groupedFilteredData: [],
    lookups: undefined,
    validationFailures: undefined,
};


function loading(state: ITrialInstitutionItemState, _isLoading: boolean): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialInstitutionItemState,
    formData: Dtos.TrialInstitutionItem | Dtos.TrialInstitutionItem[],
    groupedData: Dtos.TrialInstitutionItemCategory[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        formData: {
            $set: formData
        },
        groupedData: {
            $set: groupedData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialInstitutionItemState, formFilter: IFormFilter): ITrialInstitutionItemState {

    const data: Dtos.TrialInstitutionItem[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = data ? data.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || (p.search && p.search.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1))) : undefined;

    const groupedFilteredData = state.groupedData ? state.groupedData : [];

    const newState: ITrialInstitutionItemState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        groupedFilteredData: {
            $set: groupedFilteredData
        }
    });

    return newState;
}

function loadFailure(state: ITrialInstitutionItemState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: ITrialInstitutionItemState, _isSaving: boolean): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialInstitutionItemState,
    formData: Dtos.TrialInstitutionItem | Dtos.TrialInstitutionItem[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialInstitutionItemState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialInstitutionItemState, _isCreating: boolean): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialInstitutionItemState,
    formData: Dtos.TrialInstitutionItem,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialInstitutionItemState, responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemState {
    const newState: ITrialInstitutionItemState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialInstitutionItemState, propertiesToClear?: string[]): ITrialInstitutionItemState {

    if (!propertiesToClear) {
        const newState: ITrialInstitutionItemState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const TrialInstitutionItemReducer: Reducer<ITrialInstitutionItemState> = (state: ITrialInstitutionItemState = initialState, action: TrialInstitutionItemAction) => {
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEM_LOAD_BY_ID:
        case ACTION_TRIALINSTITUTIONITEM_LOAD_BY_TRIALINSTITUTION_ID:
        case ACTION_TRIALINSTITUTIONITEM_LOAD_SITECLOSURE:
            return loading(state, true);
        case ACTION_TRIALINSTITUTIONITEM_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.groupedData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEM_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEM_SAVE:
            return saving(state, true);
        case ACTION_TRIALINSTITUTIONITEM_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEM_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEM_CREATE:
            return creating(state, true);
        case ACTION_TRIALINSTITUTIONITEM_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALINSTITUTIONITEM_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALINSTITUTIONITEM_CLEAR:
            return clear(state, action.propertiesToClear);
    }

    return state;
}

export default TrialInstitutionItemReducer;